import React, { Fragment } from 'react'
import LockoutTimer from './LockoutTimer'

const LoginLockout = () => (
  <Fragment>
    <p>
      {__(
        'You have exceeded the login attempt limit. Your account has been temporarily locked for security purposes.',
      )}
    </p>
    <LockoutTimer />
  </Fragment>
)

export default LoginLockout
